import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Steps, Form, Input, InputNumber, Select, Button, Row, Col, Divider } from "antd";
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';

const { Option } = Select;

const NewWarehouse = ({ show, handleCanvaClose, fetchWarehouselist }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [step1Values, setStep1Values] = useState(null);

    const [userForm] = Form.useForm();
    const [warehouseForm] = Form.useForm();

    const [showVideo, setShowVideo] = useState(false);

    const handleNext = async () => {
        try {
            const values = await userForm.validateFields();
            setStep1Values(values);
            setCurrentStep(1);
        } catch (error) {
            console.log("Validation Failed:", error);
        }
    };

    const handleWarehouse = async () => {
        try {
            setLoading(true);

            const warehouseValues = await warehouseForm.validateFields();
            console.log(step1Values)
            if (!step1Values) {
                console.error("Step 1 values missing!");
                setLoading(false);
                return;
            }

            const formData = new FormData();

            // Append user values
            formData.append("name", step1Values.name);
            formData.append("email", step1Values.email);
            formData.append("phone_no", step1Values.phone);
            formData.append("password", step1Values.password);
            formData.append("role", step1Values.role);

            // Append warehouse values
            formData.append("region", warehouseValues.region);
            formData.append("wh_name", warehouseValues.warehouseName);
            formData.append("map", warehouseValues.map || "");
            formData.append("address", warehouseValues.address);
            formData.append("district", warehouseValues.district || "");
            formData.append("pincode", warehouseValues.pincode || "");
            formData.append("ofc_phn", warehouseValues.ofc_phone || "");
            formData.append("total_capacity", warehouseValues.total_capacity);

            const response = await fetch("https://ambronex.in/apis/CreateWarehouse.php", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            if (result.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: "Warehouse Created",
                    text: result.message || "Warehouse has been created successfully",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                });
                userForm.resetFields();
                warehouseForm.resetFields();
                setCurrentStep(0);
                handleClose();
                fetchWarehouselist();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: result.message || "Failed to create warehouse",
                    confirmButtonColor: "#d33",
                });
            }
        } catch (error) {
            console.error("Warehouse creation error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong! Please try again.",
                confirmButtonColor: "#d33",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        const userValues = userForm.getFieldsValue();
        const warehouseValues = warehouseForm.getFieldsValue();

        const isUserFormEmpty = Object.values(userValues).every(
            (value) => !value
        );

        const isWarehouseFormEmpty = Object.values(warehouseValues).every(
            (value) => !value
        );

        if (isUserFormEmpty && isWarehouseFormEmpty) {
            setCurrentStep(0);
            handleCanvaClose();
            userForm.resetFields();
            warehouseForm.resetFields();
        } else {
            Swal.fire({
                title: "Are you sure?",
                text: "You have unsaved changes. Do you really want to exit?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Exit",
            }).then((result) => {
                if (result.isConfirmed) {
                    setCurrentStep(0);
                    handleCanvaClose();
                    userForm.resetFields();
                    warehouseForm.resetFields();
                }
            });
        }
    };

    return (
        <Offcanvas
            show={show}
            onHide={() => handleClose()}
            placement="start"
            style={{ width: "800px" }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Create New Warehouse</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body style={{ background: "#fafafa" }}>

                <Steps
                    current={currentStep}
                    style={{ marginBottom: 25 }}
                    items={[
                        { title: "Create User" },
                        { title: "Warehouse Details" }
                    ]}
                />

                <Divider />

                {/* ================= STEP 1 ================= */}
                {currentStep === 0 && (
                    <Form layout="vertical" form={userForm}>
                        <Row gutter={16}>
                            {/* Full Name */}
                            <Col span={12}>
                                <Form.Item
                                    label="Full Name"
                                    name="name"
                                    rules={[{ required: true, message: "Enter full name" }]}
                                >
                                    <Input placeholder="Srinivasan" />
                                </Form.Item>
                            </Col>

                            {/* Email */}
                            <Col span={12}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[
                                        { required: true, message: "Enter email" },
                                        { type: "email", message: "Enter valid email" },
                                    ]}
                                >
                                    <Input placeholder="example@email.com" />
                                </Form.Item>
                            </Col>

                            {/* Phone */}
                            <Col span={12}>
                                <Form.Item
                                    label="Phone"
                                    name="phone"
                                    rules={[{ required: true, message: "Enter phone number" }]}
                                >
                                    <Input placeholder="9876543210" />
                                </Form.Item>
                            </Col>

                            {/* Role */}
                            <Col span={12}>
                                <Form.Item
                                    label="Role"
                                    name="role"
                                    rules={[{ required: true, message: "Please select role" }]}
                                >
                                    <Select placeholder="Select role" style={{ width: "100%" }}>
                                        <Select.Option value="Manager">
                                            Warehouse Manager
                                        </Select.Option>
                                        {/* Add more roles here if needed */}
                                    </Select>
                                </Form.Item>
                            </Col>

                            {/* Password */}
                            <Col span={12}>
                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[
                                        { required: true, message: "Enter password" },
                                        { min: 6, message: "Password must be at least 6 characters" },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password placeholder="Enter password" />
                                </Form.Item>
                            </Col>

                            {/* Confirm Password */}
                            <Col span={12}>
                                <Form.Item
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    dependencies={["password"]}
                                    hasFeedback
                                    rules={[
                                        { required: true, message: "Confirm your password" },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("password") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error("Passwords do not match")
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password placeholder="Confirm password" />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Next Button */}
                        <div className="text-end mt-3">
                            <Button
                                type="primary"
                                onClick={handleNext}
                            >
                                Next
                            </Button>
                        </div>
                    </Form>
                )}

                {/* ================= STEP 2 ================= */}
                {currentStep === 1 && (
                    <Form layout="vertical" form={warehouseForm}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Region"
                                    name="region"
                                    rules={[{ required: true, message: "Enter region" }]}
                                >
                                    <Input placeholder="Chennai" />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="Warehouse Name"
                                    name="warehouseName"
                                    rules={[{ required: true, message: "Enter warehouse name" }]}
                                >
                                    <Input placeholder="Warehouse A" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="Address"
                                    name="address"
                                    rules={[{ required: true, message: "Enter address" }]}
                                >
                                    <Input.TextArea rows={3} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="District"
                                    name="district"
                                    rules={[{ required: true, message: "Enter District" }]}
                                >
                                    <Input placeholder="Chennai" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Pincode"
                                    name="pincode"
                                    rules={[
                                        { required: true, message: "Enter Pincode" },
                                        { type: "number", min: 1, message: "Enter the valid Pincode" }
                                    ]}

                                >
                                    <InputNumber placeholder="600028"
                                        style={{ width: "100%" }}
                                        min={1}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Office Phone"
                                    name="ofc_phone"
                                    rules={[
                                        // { message: "Enter Pincode" },
                                        { type: "number", min: 1, message: "Enter the valid Phone Number" }
                                    ]}
                                >
                                    <InputNumber placeholder="9876543210"
                                        style={{ width: "100%" }}
                                        min={1}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="Total Capacity of Warehouse (in Units)"
                                    name="total_capacity"
                                    rules={[
                                        { required: true, message: "Please enter the total capacity" },
                                        { type: "number", min: 1, message: "Capacity must be greater than 0" }
                                    ]}
                                >
                                    <InputNumber
                                        placeholder="Total Capacity"
                                        style={{ width: "100%" }}
                                        min={1}
                                    />
                                </Form.Item>
                            </Col>


                            {/* <div style={{ marginTop: '10px' }}> */}

                            <Col span={24}>
                                <Form.Item
                                    label="Map"
                                    name="map"
                                    rules={[{ required: true, message: "Please enter the embed map link" }]}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <Input style={{ flex: 1 }} placeholder="Map URL" />

                                        <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>
                                            <button
                                                type="button"
                                                className="btn btn-sm text-primary p-0 me-1"
                                                onClick={() => setShowVideo(true)}
                                                title="Watch Demo"
                                                style={{ fontSize: "1.2rem" }}
                                            >
                                                <i className="bi bi-play-circle-fill"></i>
                                            </button>
                                            <span className="fs-6 text-secondary mb-0">Demo</span>
                                        </div>
                                    </div>
                                </Form.Item>
                            </Col>


                            {/* Bootstrap Modal for Video */}
                            <Modal
                                show={showVideo}
                                onHide={() => setShowVideo(false)}
                                size="lg"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Demo Video</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="ratio ratio-16x9">
                                        <video
                                            src="https://ambronex.in/images/demovideo/map.mp4"
                                            autoPlay
                                            controls
                                            muted
                                        />
                                    </div>
                                </Modal.Body>
                            </Modal>
                            {/* </div> */}

                        </Row>

                        <div className="d-flex justify-content-between mt-3">
                            <Button onClick={() => setCurrentStep(0)}>
                                Previous
                            </Button>

                            <Button type="primary" onClick={handleWarehouse} loading={loading}>
                                Create Warehouse
                            </Button>
                        </div>
                    </Form>
                )}

            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default NewWarehouse;